import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Grid, Condition } from '../../../models';
import { ConditionsBuilder } from '../../../elements';

export function NewFilterPage(props: { onSaved: () => void }) {
  const [submitting, setSubmitting] = useState(false);
  const [loadingDataSets, setLoadingDataSets] = useState(false);
  const [dataSets, setDataSets] = useState<Grid[]>([]);
  const [selectedDataSet, setSelectedDataSet] = useState<Grid>();
  const [conditions, setConditions] = useState<Condition>();

  const [form] = Form.useForm();

  useEffect(() => {
    setLoadingDataSets(true);
    apiClient
      .get('grids')
      .then((response: any) => {
        setDataSets(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoadingDataSets(false);
      });
  }, []);

  const onDataSetChange = (value: string) => {
    setSelectedDataSet(dataSets.find(t => t.id === value));
    form.setFieldsValue({
      conditions: undefined,
    });
  };

  const onFinish = (values: any) => {
    const body = {
      ...values,
      conditions,
    };
    setSubmitting(true);
    apiClient
      .post('filters', body)
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Form labelCol={{ span: 2 }} wrapperCol={{ span: 22 }} onFinish={onFinish} form={form}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          {
            pattern: /^[a-zA-Z0-9ıİğĞüÜşŞöÖçÇ][a-zA-Z0-9_\-ıİğĞüÜşŞöÖçÇ\s]*$/,
            message: 'Sadece harf, rakam, boşluk, - ve _ karakteri kullanılabilir',
          },
          { max: 100, message: 'En fazla 100 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Açıklama"
        name="description"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 400, message: 'En fazla 400 karakter' },
        ]}
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item label="Veri seti" name="dataSetId" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <Select options={dataSets.map(t => ({ label: t.name, value: t.id }))} loading={loadingDataSets} onChange={onDataSetChange} />
      </Form.Item>

      <Form.Item label="Koşullar" name="conditions">
        <ConditionsBuilder
          dataSetId={selectedDataSet?.id}
          pendingSelectMessage="Koşullar için bir veri seti seçin"
          onChange={setConditions}
        />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 2, span: 22 }}>
        <Button type="primary" htmlType="submit" loading={submitting}>
          Ekle
        </Button>
      </Form.Item>
    </Form>
  );
}
